import { useRef, type MutableRefObject } from 'react';

/**
 * A ref that always holds the latest value, updated during render.
 *
 * Lets long-lived callbacks and D3 event handlers read current state without being torn down
 * and rebound on every change. The assignment is deliberately render-phase (not an effect),
 * matching the hand-written `const xRef = useRef(x); xRef.current = x;` idiom this replaces —
 * an effect would leave the ref one commit stale for anything reading it during that commit.
 */
export function useLatest<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
